module.exports = __webpack_public_path__ + "img/mobilita_sicura_nucleo.f037a4f7.jpg";